import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function ForWhoSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section className="w-full py-24 px-6" style={{
    background: '#0D1B2A'
  }} data-id="element-78">
      <div className="max-w-4xl mx-auto" data-id="element-79">
        <div ref={ref} className={`reveal ${isVisible ? 'visible' : ''}`} data-id="element-80">
          <div className="amber-divider mb-8" data-id="element-81" />
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" style={{
          fontFamily: 'Playfair Display, serif',
          color: '#F5F0E8'
        }} data-id="element-82">
            Est-ce fait pour vous ?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-83">
            {/* For who */}
            <div className="rounded-2xl p-6 md:p-8" style={{
            background: 'rgba(212,168,83,0.05)',
            border: '1px solid rgba(212,168,83,0.2)'
          }} data-id="element-84">
              <h3 className="text-lg font-bold mb-6 flex items-center gap-2" style={{
              fontFamily: 'Playfair Display, serif',
              color: '#D4A853'
            }} data-id="element-85">
                <span data-id="element-86">✓</span> C'est pour vous si...
              </h3>
              <ul className="space-y-4" data-id="element-87">
                <li className="flex gap-3" data-id="element-88">
                  <span className="flex-shrink-0 mt-0.5" style={{
                  color: '#D4A853'
                }} data-id="element-89">
                    ✓
                  </span>
                  <p className="text-sm leading-relaxed" style={{
                  fontFamily: 'DM Sans, sans-serif',
                  color: '#C8C0B0'
                }} data-id="element-90">
                    Vous êtes en phase de séparation ou récemment divorcée et
                    vous vous sentez submergée.
                  </p>
                </li>
                <li className="flex gap-3" data-id="element-91">
                  <span className="flex-shrink-0 mt-0.5" style={{
                  color: '#D4A853'
                }} data-id="element-92">
                    ✓
                  </span>
                  <p className="text-sm leading-relaxed" style={{
                  fontFamily: 'DM Sans, sans-serif',
                  color: '#C8C0B0'
                }} data-id="element-93">
                    Vous souffrez de "cerveau qui mouline" dès que la lumière
                    s'éteint.
                  </p>
                </li>
                <li className="flex gap-3" data-id="element-94">
                  <span className="flex-shrink-0 mt-0.5" style={{
                  color: '#D4A853'
                }} data-id="element-95">
                    ✓
                  </span>
                  <p className="text-sm leading-relaxed" style={{
                  fontFamily: 'DM Sans, sans-serif',
                  color: '#C8C0B0'
                }} data-id="element-96">
                    Vous êtes mère solo et avez besoin de chaque minute de
                    sommeil pour assumer le lendemain.
                  </p>
                </li>
                <li className="flex gap-3" data-id="element-97">
                  <span className="flex-shrink-0 mt-0.5" style={{
                  color: '#D4A853'
                }} data-id="element-98">
                    ✓
                  </span>
                  <p className="text-sm leading-relaxed" style={{
                  fontFamily: 'DM Sans, sans-serif',
                  color: '#C8C0B0'
                }} data-id="element-99">
                    Vous vous réveillez en panique au milieu de la nuit avec des
                    palpitations.
                  </p>
                </li>
              </ul>
            </div>

            {/* Not for who */}
            <div className="rounded-2xl p-6 md:p-8" style={{
            background: 'rgba(13,27,42,0.8)',
            border: '1px solid rgba(255,255,255,0.06)'
          }} data-id="element-100">
              <h3 className="text-lg font-bold mb-6 flex items-center gap-2" style={{
              fontFamily: 'Playfair Display, serif',
              color: '#8A8070'
            }} data-id="element-101">
                <span data-id="element-102">✗</span> Ce n'est pas pour vous si...
              </h3>
              <ul className="space-y-4" data-id="element-103">
                <li className="flex gap-3" data-id="element-104">
                  <span className="flex-shrink-0 mt-0.5" style={{
                  color: '#8A8070'
                }} data-id="element-105">
                    ✗
                  </span>
                  <p className="text-sm leading-relaxed" style={{
                  fontFamily: 'DM Sans, sans-serif',
                  color: '#8A8070'
                }} data-id="element-106">
                    Vous cherchez une pilule miracle sans changer vos habitudes
                    de 22h.
                  </p>
                </li>
                <li className="flex gap-3" data-id="element-107">
                  <span className="flex-shrink-0 mt-0.5" style={{
                  color: '#8A8070'
                }} data-id="element-108">
                    ✗
                  </span>
                  <p className="text-sm leading-relaxed" style={{
                  fontFamily: 'DM Sans, sans-serif',
                  color: '#8A8070'
                }} data-id="element-109">
                    Vous n'êtes pas prête à consacrer 10 minutes à votre
                    bien-être nerveux.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}